import { useQueryStates, parseAsString, parseAsInteger } from "nuqs";

export function useHistoryFilters() {
  return useQueryStates({
    model_type: parseAsString,
    action: parseAsInteger,
    ordering: parseAsString.withDefault("-timestamp"),
    object_pk: parseAsString,
    search: parseAsString,
  });
}
